import { render, staticRenderFns } from "./ItsContractLabor.vue?vue&type=template&id=4ad0818c&scoped=true&"
import script from "./ItsContractLabor.vue?vue&type=script&lang=js&"
export * from "./ItsContractLabor.vue?vue&type=script&lang=js&"
import style0 from "./ItsContractLabor.vue?vue&type=style&index=0&id=4ad0818c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0818c",
  null
  
)

export default component.exports